module.exports = __webpack_public_path__ + "static/media/r-bahn.5d59e8f8.svg";